(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-personalized"]) return;
  try {
    
    document.addEventListener("DOMContentLoaded", function () {
    const select = document.getElementById("product-variant");
    const allInputs = document.querySelectorAll('.mo-pr-field, .mo-pr-field2');
    const hiddenPersonalized = document.querySelector('input[name="properties[Personalized]"]');
    const hiddenPersonalized2 = document.querySelector('input[name="properties[Personalized2]"]');

    function toggleInputs() {
        const selectedValue = select.value;

        // Hide all first
        allInputs.forEach(input => {
        input.style.display = "none";
        input.removeAttribute("required");
        });

        // Show matching inputs
        const matchingInputs = document.querySelectorAll(`.mo-pr-field[data-value="${selectedValue}"], .mo-pr-field2[data-value="${selectedValue}"]`);
        matchingInputs.forEach(input => {
        input.style.display = "block";
        input.setAttribute("required", "true");
        });
    }

    // Copy visible input values to hidden fields before submit
    function syncHiddenFields() {
        const visiblePersonalized = document.querySelector('.mo-pr-field[style*="block"]');
        const visiblePersonalized2 = document.querySelector('.mo-pr-field2[style*="block"]');

        hiddenPersonalized.value = visiblePersonalized ? visiblePersonalized.value : "";
        hiddenPersonalized2.value = visiblePersonalized2 ? visiblePersonalized2.value : "";
    }

    // Run once on load
    toggleInputs();

    // Run on change
    select.addEventListener("change", toggleInputs);

    // Sync on input
    allInputs.forEach(input => {
        input.addEventListener("input", syncHiddenFields);
    });

    // Sync on form submit (safety net)
    document.querySelector("form").addEventListener("submit", syncHiddenFields);
    });

  } catch(e) { console.error(e); }
})();
})();
